import { render } from "./ProjectPublicationHistoryListItemMediaItemsImage.vue?vue&type=template&id=4126680c&scoped=true"
import script from "./ProjectPublicationHistoryListItemMediaItemsImage.vue?vue&type=script&lang=js"
export * from "./ProjectPublicationHistoryListItemMediaItemsImage.vue?vue&type=script&lang=js"

import "./ProjectPublicationHistoryListItemMediaItemsImage.vue?vue&type=style&index=0&id=4126680c&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4126680c"]])

export default __exports__